
.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--zindex-alert-dialog-background);
  background-color: var(--modal-backdrop-bg);
  opacity: var(--modal-backdrop-opacity);
  transition: opacity 0.15s linear;
}

.backdrop[data-starting-style],
.backdrop[data-ending-style] {
  opacity: 0;
}

.viewport {
  position: fixed;
  inset: 0;
  z-index: var(--zindex-alert-dialog);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 30px 10px;
  overflow-y: auto;
}

.content {
  position: relative;
  width: var(--modal-md);
  max-width: 100%;
  background-color: var(--modal-content-bg);
  border-radius: var(--border-radius-base);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  overflow: hidden;
  outline: 0;
  transition:
    opacity 0.3s ease-out,
    transform 0.3s ease-out;
}

.content[data-starting-style],
.content[data-ending-style] {
  opacity: 0;
  transform: translateY(-25%);
}

.sizeXs {
  width: var(--modal-xs);
}
.sizeSm {
  width: var(--modal-sm);
}
.sizeLg {
  width: var(--modal-lg);
}
.sizeXl {
  width: var(--modal-xl);
}
.sizeFull {
  width: var(--modal-full);
}

.header {
  position: relative;
  padding: var(--modal-title-padding) var(--modal-title-padding) 0;
}

.variationPrimary [data-slot="alert-dialog-header"],
.variationSuccess [data-slot="alert-dialog-header"],
.variationInfo [data-slot="alert-dialog-header"],
.variationWarning [data-slot="alert-dialog-header"],
.variationDanger [data-slot="alert-dialog-header"] {
  padding: var(--content-padding-base) var(--modal-inner-padding);
  color: #fff;
}

.variationPrimary [data-slot="alert-dialog-header"] {
  background-color: var(--color-primary);
}
.variationSuccess [data-slot="alert-dialog-header"] {
  background-color: var(--color-success-500);
}
.variationInfo [data-slot="alert-dialog-header"] {
  background-color: var(--color-info-500);
}
.variationWarning [data-slot="alert-dialog-header"] {
  background-color: var(--color-warning-500);
}
.variationDanger [data-slot="alert-dialog-header"] {
  background-color: var(--color-danger-400);
}

.variationPrimary .close,
.variationSuccess .close,
.variationInfo .close,
.variationWarning .close,
.variationDanger .close {
  color: #fff;
}

.title {
  margin: 0;
  color: inherit;
}

/* Unlike a dialog's description (a subtitle under the title), an alert dialog's
   description IS the message — so it reads as normal body copy, not muted. */
.description {
  margin: 5px 0 0;
}

.body {
  position: relative;
  padding: var(--modal-inner-padding);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  padding: 0 var(--modal-inner-padding) var(--modal-inner-padding);
}

.close {
  position: absolute;
  top: 15px;
  right: var(--modal-inner-padding);
  z-index: 1;
  padding: 0;
  border: 0;
  border-radius: 3px;
  background: transparent;
  -webkit-appearance: none;
  appearance: none;
  font-size: calc(var(--font-size-base) * 1.5); /* 19.5px */
  font-weight: var(--close-font-weight);
  line-height: 1;
  color: var(--close-color);
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 0.15s ease-in-out;
}

.close:hover,
.close:focus {
  opacity: 1;
  outline: 0;
}

.close:focus-visible {
  outline: 2px solid #648cff;
  outline-offset: 2px;
}
